import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Purchase invoices moved to a separate app. Old email links (/PurchaseInvoice,
// /i-v/, /i-r/, /v-a/, /clarification/) are forwarded there with the same path.
const LegacyPurchaseInvoiceRedirect = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_PURCHASE_INVOICES_URL?.replace(/\/$/, "");
    if (baseUrl) {
      window.location.replace(`${baseUrl}${pathname}${search}${hash}`);
    }
  }, [pathname, search, hash]);

  return null;
};

export default LegacyPurchaseInvoiceRedirect;
